const preferences = `{
    items {
        id
        title
        short_description
        description
        customer_preference {
            notification_type
            is_checked
        }
    }
    phone
    page_config {
        title
        description
        bottom_description
        buttons {
            type
            label
            disabled
        }
    }
}`;

const getPreferencesOpt = `
    query getPreferencesOpt($input:GetPreferencesOptInput) {
        getPreferencesOpt(input: $input)
        ${preferences}
    }
`;

const updateNotificationPreferences = `
    mutation UpdateNotificationPreferences($input: UpdateNotificationPreferencesInput) {
        updateNotificationPreferences(input: $input)
        ${preferences}
    }
`;

export default {
    getPreferencesOpt,
    updateNotificationPreferences,
};
